"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorSidebar = ErrorSidebar;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ErrorSidebarListItem(_ref) {
  var label = _ref.label;
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: "ErrorSidebarListItem"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "ErrorSidebarLabel"
  }, label));
}

function ErrorSidebar(_ref2) {
  var labels = _ref2.labels;
  var hasErrors = labels && labels.length > 0;

  if (hasErrors) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "ErrorSidebar"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "ErrorSidebarMessage"
    }, "The following fields require attention:"), /*#__PURE__*/_react["default"].createElement("ul", {
      className: "ErrorSidebarList"
    }, labels.map(function (label) {
      return /*#__PURE__*/_react["default"].createElement(ErrorSidebarListItem, {
        label: label
      });
    })));
  } else {
    return /*#__PURE__*/_react["default"].createElement("div", null);
  }
}

ErrorSidebar.propTypes = {
  labels: _propTypes["default"].arrayOf(_propTypes["default"].string)
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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